/*
 * @Descripttion:
 * @Author: Jun Chen
 * @Date: 2021-1-22 23:07:49
 */
export default [
  {
    path: '/sealShare',
    name: 'sealShare',
    hidden: false,
    meta: {
      title: '分销数据',
      icon: '',
      nav: 'act',
      level: 1
    },
    component: resolve => require(['@/views/Application.vue'], resolve),
    children: [
      {
        path: '/sealShareIndex',
        name: 'sealShareIndex',
        hidden: false,
        meta: {
          title: '分销数据',
          level: 1,
          nav: 'act',
          icon: ''
        },
        component: resolve => require(['@/views/seal-share-manage/manage'], resolve)
      }
    ]
  }
]



// WEBPACK FOOTER //
// ./src/router/modules/router-seal-share-manage.js